/**
 * Runtime maze emojis. Initial values are platform fallbacks; the actual
 * production values are written here by `setMazeEmojis()` from the maze
 * page server component, which reads them from `MazeEmojiSettingsService`
 * (Postgres + Redis-cached, admin-controlled).
 *
 * Renderer helpers (canvas, print SVG) keep their `MAZE_EMOJIS.entrance`
 * call sites — the object is mutated in place so the new values propagate
 * without changing every consumer.
 */
export const MAZE_EMOJIS: { entrance: string; exit: string } = {
  entrance: '👩',
  exit: '☕️',
};

/** Replace the runtime emojis. Called once on maze-page hydration. */
export function setMazeEmojis(start: string, end: string): void {
  MAZE_EMOJIS.entrance = start;
  MAZE_EMOJIS.exit = end;
}
